// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime, Duration } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ReminderSystemSetting {
  readonly id: string;
  readonly isActive: boolean;
  readonly recordType: Enums.ReminderSystemRecordType;
  readonly activityCategory: Enums.ActivityCategory | null;
  readonly recordBusinessDate: Enums.ReminderSystemBusinessDate;
  readonly notifyBefore: Duration;
  readonly note: string | null;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.isActive = data.isActive === undefined ? false : data.isActive;
    this.recordType =
      data.recordType === undefined ? Enums.ReminderSystemRecordType.Project : data.recordType;
    this.activityCategory = data.activityCategory === undefined ? null : data.activityCategory;
    this.recordBusinessDate =
      data.recordBusinessDate === undefined
        ? Enums.ReminderSystemBusinessDate.BidDate
        : data.recordBusinessDate;
    this.notifyBefore = DateHelpers.ParseServerDuration(data.notifyBefore);
    this.note = data.note === undefined ? null : data.note;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): ReminderSystemSetting {
    const zeroValues: ExcludeMethodsDeep<ReminderSystemSetting> = {
      id: NIL_UUID,
      isActive: false,
      recordType: Enums.ReminderSystemRecordType.Project,
      activityCategory: null,
      recordBusinessDate: Enums.ReminderSystemBusinessDate.BidDate,
      notifyBefore: DateHelpers.ParseServerDuration(DateHelpers.ZERO_DURATION_STRING),
      note: null,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      isArchived: false,
    };
    return new ReminderSystemSetting(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReminderSystemSettingWireFormat = {
  id: string;
  isActive: boolean;
  recordType: string;
  activityCategory: string | null;
  recordBusinessDate: string;
  notifyBefore: string;
  note: string | null;
  createdAt: string;
  updatedAt: string;
  isArchived: boolean;
};

type NewReminderSystemSettingProps = PartialDeep<
  ReminderSystemSetting,
  { recurseIntoArrays: true }
>;
export const NewReminderSystemSetting: (
  props: NewReminderSystemSettingProps,
) => ReminderSystemSetting = (props) => new ReminderSystemSetting(props);

type NewReminderSystemSettingFromWireFormatProps = PartialDeep<
  ReminderSystemSettingWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReminderSystemSettingFromWireFormat: (
  props: NewReminderSystemSettingFromWireFormatProps,
) => ReminderSystemSetting = (props) => new ReminderSystemSetting(props);
